import { Component, Vue } from 'vue-property-decorator'
import LHeader from '@/components/Layout/LHeader/index.vue'
import Loader from '@/components/Loader/index.vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { install } from '@/serviceWorkerRegistration'
import api from '@/helpers/fetch'
import store from '@/store/store.js'

@Component({
	components: {
		Loader,
		LHeader,
	},
})
export default class Layout extends Vue {
	get fontLoaded() {
		return this.$store.state.font.loaded
	}

	updated() {
		install()
	}

	async closeWelcome() {
		this.$bvModal.hide('modal-welcome')
		await api.post('/api/my-account/profile/first-access', {})
	}

	mounted() {
		if (store.user.first_access) {
			this.$bvModal.show('modal-welcome')
		}
	}
}
